import React, { useEffect, useState } from 'react';
import axios from 'axios';
import AppHeader from '../Organism/AppHeader';
import { Layout, Breadcrumb, Card, Row, Col, Statistic, Divider } from 'antd';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import '../Atoms/AdminPage.css';
import FunnelChart from '../Organism/FunnelChart';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../../authConfig';

const { Content, Footer } = Layout;

const Dashboard = () => {
    const { instance, accounts } = useMsal();
    const [data, setData] = useState<{ name: string; value: any; }[]>([]);
    const baseURL = process.env.REACT_APP_API_URL;
    const [statistics, setStatistics] = useState({
        totalNominees: 0,
        managerApproved: 0,
        firstLevelApproved: 0,
        secondLevelApproved: 0,
        winners: 0,
    });

    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await instance.acquireTokenSilent({
                    ...loginRequest,
                    account: accounts[0]
                });
                const response = await axios.get(`${baseURL}/api/nominations/stats`, {
                    headers: {
                        Authorization: `Bearer ${res.idToken}`
                    }
                });
                const stats = response.data;

                setData([
                    { name: 'Total Nominees', value: stats.totalNominations },
                    { name: 'Manager Approved', value: stats.managerApprovedNominations },
                    { name: 'First Level Approved', value: stats.firstLevelApprovedNominations },
                    { name: 'Second Level Approved', value: stats.secondLevelApprovedNominations },
                    { name: 'Winners', value: stats.finalLevelApprovedNominations },
                ]);

                setStatistics({
                    totalNominees: stats.totalNominations,
                    managerApproved: stats.managerApprovedNominations,
                    firstLevelApproved: stats.firstLevelApprovedNominations,
                    secondLevelApproved: stats.secondLevelApprovedNominations,
                    winners: stats.finalLevelApprovedNominations,
                });
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, [instance, accounts, baseURL]);

    const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#AA336A'];

    return (
        <div>
            <Layout style={{ display: 'flex' }}>
                <div style={{ flex: '1', display: 'flex', flexDirection: 'column' }}>
                    <AppHeader subtitle={'Dashboard'} />
                </div>
            </Layout>
            <Layout className="layout">
                <Content style={{
                        padding: '0 16px',
                        maxWidth: '1200px',
                        margin: '0 auto',
                        width: '100%', // Ensure it doesn't overflow
                        boxSizing: 'border-box',
                    }}>
                    <Breadcrumb style={{ margin: '16px 0' }}>
                        <Breadcrumb.Item>Home</Breadcrumb.Item>
                        <Breadcrumb.Item>Dashboard</Breadcrumb.Item>
                    </Breadcrumb>
                    <div className="site-layout-content">
                        <Row gutter={[16, 16]} justify="center">
                            <Col xs={24} sm={12} md={8} lg={6}>
                                <Card>
                                    <Statistic title="Total Nominees" value={statistics.totalNominees} />
                                </Card>
                            </Col>
                            <Col xs={24} sm={12} md={8} lg={6}>
                                <Card>
                                    <Statistic title="Manager Approved" value={statistics.managerApproved} />
                                </Card>
                            </Col>
                            <Col xs={24} sm={12} md={8} lg={6}>
                                <Card>
                                    <Statistic title="First Level Approved" value={statistics.firstLevelApproved} />
                                </Card>
                            </Col>
                            <Col xs={24} sm={12} md={8} lg={6}>
                                <Card>
                                    <Statistic title="Second Level Approved" value={statistics.secondLevelApproved} />
                                </Card>
                            </Col>
                            <Col xs={24} sm={12} md={8} lg={6}>
                                <Card>
                                    <Statistic title="Winners" value={statistics.winners} />
                                </Card>
                            </Col>
                        </Row>
                        <Row style={{ marginTop: '20px' }}>
                            <Col xs={24}>
                                <Card title="Approval Statistics">
                                    <div style={{ width: '100%', height: 350 }}>
                                        <ResponsiveContainer width="100%" height="100%">
                                            <PieChart>
                                                <Pie
                                                    data={data}
                                                    cx="50%"
                                                    cy="50%"
                                                    labelLine={false}
                                                    label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
                                                    outerRadius="80%"
                                                    fill="#8884d8"
                                                    dataKey="value"
                                                >
                                                    {data.map((entry, index) => (
                                                        <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                                    ))}
                                                </Pie>
                                                <Tooltip />
                                                <Legend />
                                            </PieChart>
                                        </ResponsiveContainer>
                                    </div>
                                    <Divider />
                                    <FunnelChart statistics={statistics} />
                                </Card>
                            </Col>
                        </Row>
                    </div>
                </Content>
                <Footer style={{ textAlign: 'center' }}>
                    Copyright ©{new Date().getFullYear()} Created by Aptean
                </Footer>
            </Layout>
            {/* Responsive styles */}
            <style>
    {`
    @media (max-width: 768px) {
        .site-layout-content {
            padding: 0 !important;
        }
        .ant-card {
            margin-bottom: 12px;
        }
        .ant-layout-content {
            max-width: 100vw !important;
            width: 100vw !important;
            overflow-x: hidden !important;
        }
    }
    `}
</style>
        </div>
    );
}

export default Dashboard;